import { lazy, Suspense } from 'react';
import R2Image from '@/components/custom-image/r2Image';
import CoinAndLevelUp from '@/components/level-up/coin-levelup';
import { DMLink } from '@/components/link';
import DMVideo from '@/components/video';
import { formatDateToDDMMMYYYY } from '@/lib/utils';
import ReactPlayer from 'react-player';
import CourseFeatures from './course-features';
import CourseDetailsHeader from './header';
import PaymentButton from './razorpay/PaymentButton';
import type { CourseDetailsProps } from './types';

const CourseIntroVideo = lazy(() => import('./intro-video'));

export const CourseDetailsLg = ({ className, courseDetails }: CourseDetailsProps) => {
  console.log(courseDetails?.chapters?.[0]?.lectures?.[0], '====video');

  return (
    <div className={`justify-between ${className}`}>
      <CourseDetailsHeader
        title={courseDetails?.title}
        description={courseDetails?.description || ''}
        createdBy='Debug Media'
        updatedOn={formatDateToDDMMMYYYY(courseDetails?.updatedAt)}
      />
      <div className='mt-5 md:-mt-8'>
        <div className='lg:w-[400px] bg-brand-secondary p-5 rounded-xl pb-5'>
          <div className='h-[220px]'>
            {/* <R2Image
              fileName={courseDetails.thumbnailImage as string}
              width={390}
              height={220}
              className='w-full h-full object-contain'
            /> */}

            <Suspense fallback={null}>
              <CourseIntroVideo link={courseDetails?.chapters?.[0]?.lectures?.[0]?.link ?? ''} />
            </Suspense>
          </div>
          <div className='mt-5 px-2'>
            {courseDetails?.orders?.[0]?.active ? (
              <DMLink
                className='flex items-center justify-center mb-4'
                href={`/courses/${courseDetails?.slug}/${courseDetails?.chapters?.[0]?.lectures?.[0]?.slug}`}
                variant='primary_outline'
              >
                Go to course
              </DMLink>
            ) : (
              <PaymentButton courseDetails={courseDetails} />
            )}
            <CourseFeatures />
            <div className='-ml-2 mt-2'>
              <CoinAndLevelUp coin={courseDetails?.coin} points={courseDetails?.point} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
